(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('MaintenanceTypeFormController', MaintenanceTypeFormController);
    

    MaintenanceTypeFormController.$inject = [
        '$stateParams',
        'tipoMantenimientoService',
        'genericDataService',
        '$filter',
        '$state',
        '$rootScope',
        'notificationService',
        '$scope',
        'common'
    ];

    function MaintenanceTypeFormController($stateParams, tipoMantenimientoService, genericDataService,
        $filter, $state, $rootScope, notificationService, $scope, common){


        var id = $stateParams.id;

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.stateParams = $stateParams;
        vm.tipoMantenimiento = {};
        vm.edit = false;

        vm.tipo = {
            list: [
                { 'nombre': 'Por Kms Vehículo', 'id': 0 },
                { 'nombre': 'Tiempo', 'id': 1 },
                { 'nombre': 'Lo que suceda antes', 'id': 2 }

            ],
            selected: { 'nombre': 'Por Kms Vehículo', 'id': 0 }
        };

        vm.tiempo = {
            list: [
                { 'nombre': 'días', 'id': 0 },
                { 'nombre': 'meses', 'id': 1 },
                { 'nombre': 'años', 'id': 2 }

            ],
            selected: { 'nombre': 'días', 'id': 0 }
        };


        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;
        vm.effectClass = effectClass;
        vm.resizable = resizable;

        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;

        vm.accionSaveList = [
            {
                accionTexto: 'Guardar y cerrar',
                accion: vm.saveAndClose,
                selected: computeValueAccionSelected('guardarCerrar')
            },
            {
                accionTexto: 'Guardar y nuevo',
                accion: vm.saveAndNew,
                selected: computeValueAccionSelected('saveAndNew')
            },
            {
                accionTexto: 'Guardar',
                accion: vm.save,
                selected: computeValueAccionSelected('save')
            },
        ];

        /* INITIALIZER */
        (function () {
            if (id != null) {
                vm.edit = true;
                tipoMantenimientoService.getById(id)
                    .then(function (result) {

                        vm.tipoMantenimiento = result;

                        if (!common.isNullOrUndefined(vm.tipoMantenimiento.tipoVencimientoId) && vm.tipoMantenimiento.tipoVencimientoId == 1) vm.tipo.selected = vm.tipo.list[1];
                        else if (!common.isNullOrUndefined(vm.tipoMantenimiento.tipoVencimientoId) && vm.tipoMantenimiento.tipoVencimientoId == 2) vm.tipo.selected = vm.tipo.list[2];
                        else vm.tiempo.selected = vm.tiempo.list[0];

                        if (!common.isNullOrUndefined(vm.tipoMantenimiento.intervaloTiempoTipo) && vm.tipoMantenimiento.intervaloTiempoTipo == 1) vm.tiempo.selected = vm.tiempo.list[1];
                        else if (!common.isNullOrUndefined(vm.tipoMantenimiento.intervaloTiempoTipo) && vm.tipoMantenimiento.intervaloTiempoTipo == 2) vm.tiempo.selected = vm.tiempo.list[2];
                        else vm.tiempo.selected = vm.tiempo.list[0];
                    });
            }
        })();

        function computeValueAccionSelected(accion) {
            if (accion === vm.stateParams.accion) { return true; }
            return false;
        }



        /* PRIVATE FUNCTIONS */

        function doSave(action) {
            vm.tipoMantenimiento.tipoVencimientoId = vm.tipo.selected.id;
            vm.tipoMantenimiento.intervaloTiempoTipo = vm.tiempo.selected.id;

            tipoMantenimientoService.add(vm.tipoMantenimiento).then(function (obj) {
                sendSAveNotification();
                vm.edit = true;
                if (action === 'saveAndClose') {
                    $state.go('flota.configuracion.tiposMantenimientos');
                }
                else if (action === 'saveAndNew') {
                    $state.go('flota.configuracion.nuevoTipoMantenimiento', { 'accion': 'saveAndNew' });
                }
                
            });
        }

        function save() {
            var action = 'save';
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            doSave(action);
        }

        function saveAndClose() {
            var action = 'saveAndClose';
            doSave(action);
        }

        function saveAndNew() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            var action = 'saveAndNew';
            doSave(action);
        }

        function sendSAveNotification() {
            notificationService.sendAppNotification({
                message: 'El tipo mantenimiento se ha guardado correctamente',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
        }


        // Try to find the selected element in the list using the id property
        // If requireId is false it will keep the name even when id is null

        function effectClass(target) {
            vm.effects = {};
            vm.effects[target] = true;
            setTimeout(function () {
                vm.effects[target] = undefined;
            }, 3000);
        }

        function resizableInput(el, factor) {
            var int = Number(factor) || 7.7;
            function resize() { el.style.width = ((el.value.length + 1) * int) + 'px'; }
            var e = 'keyup,keypress,focus,blur,change'.split(',');
            for (var i in e) { el.addEventListener(e[i], resize, false); }
            resize();
        }

        function resizable() {
            resizableInput(document.getElementById('txt'), 7);
        }

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if (!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }

    }

})();